import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_BILLS_TO_PAY,
  GET_BILLS_TO_PAY_BY_HASH,
  CREATE_BILLS_TO_PAY,
  UPDATE_BILLS_TO_PAY,
  DELETE_BILLS_TO_PAY,
} from './actionType';

const INIT_STATE = {
  bills: [],
  summary: {},
  billsByHashId: {},
  error: {},
  success: null,
  loading: true,
};

const BillsToPay = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_BILLS_TO_PAY:
          return {
            ...state,
            bills: action.payload.data.data,
            summary: action.payload.data.summary,
            success: null,
            error: {},
            billsByHashId: {},
            loading: false,
          };
        case GET_BILLS_TO_PAY_BY_HASH:
          return {
            ...state,
            billsByHashId: action.payload.data,
            success: null,
            error: {},
          };
        case CREATE_BILLS_TO_PAY:
          return {
            ...state,
            success: 'Successfully created bill to pay',
            error: {},
          };
        case UPDATE_BILLS_TO_PAY:
          return {
            ...state,
            success: 'Successfully updated bill to pay',
            error: {},
          };
        case DELETE_BILLS_TO_PAY:
          return {
            ...state,
            success: 'Successfully deleted bill to pay',
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_BILLS_TO_PAY:
          return {
            ...state,
            success: '',
            error: action.payload.error,
            loading: false,
          };
        case GET_BILLS_TO_PAY_BY_HASH:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case CREATE_BILLS_TO_PAY:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case UPDATE_BILLS_TO_PAY:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case DELETE_BILLS_TO_PAY: {
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        }
        default:
          return { ...state };
      }
    case GET_BILLS_TO_PAY: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_BILLS_TO_PAY_BY_HASH: {
      return {
        ...state,
      };
    }
    case CREATE_BILLS_TO_PAY: {
      return {
        ...state,
      };
    }
    case UPDATE_BILLS_TO_PAY: {
      return {
        ...state,
      };
    }
    case DELETE_BILLS_TO_PAY: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default BillsToPay;
